import { Link } from "gatsby"
import { NavLink } from "../craft"
import { useSupportFooterNav } from "../../hooks/useSupportFooterNav"

import AboriginalFlag from "../../images/AboriginalFlag.jpg"
import TorresStraitIslanderFlag from "../../images/TorresStraitIslanderFlag.jpg"
import LGBTFlag from "../../images/LGBTFlag.jpg"
import { Facebook, Twitter, Linkedin, Vimeo } from "../svgIcons"
import Slack from "../../images/slack.svg"

import Img1 from "../../images/bcorp.svg"

export const SiteFooter = () => {
  const { supportNav, companyNav } = useSupportFooterNav()
  return (
    <div className="container mx-auto">
      <div className="justify-center gap-6 p-8 md:flex">
        <div className="flex-1">
          <div className="flex pt-5 pb-1 cursor-pointer max-w-xs">
            <Link to="/" className="mr-2">
              <img
                src={AboriginalFlag}
                alt="Aboriginal Flag"
                className="text-white w-80 2xl:w-96"
              />
            </Link>
            <Link to="/" className="mr-2">
              <img
                src={TorresStraitIslanderFlag}
                alt="Torres Strait Islander Flag"
                className="text-white w-80 2xl:w-96"
              />
            </Link>
            <Link to="/" className="mr-2">
              <img
                src={LGBTFlag}
                alt="LGBT Flag"
                className="text-white w-80 2xl:w-96"
              />
            </Link>
            {/* <Link to="/">
              <img
                src={footerAboriginal}
                alt="Aboriginal flag"
                className="h-10 mb-3 ml-5 text-white 2xl:w20"
              />
            </Link> */}
          </div>
          <div>
            {/* <h1 className="py-5 text-xl font-semibold text-secondary">Recognition</h1> */}
            <p className="mt-2 text-xs font-normal leading-tight text-secondary">
              We&apos;re based in Melbourne, on the traditional lands of the
              Woiwurrung and Boon Wurrung peoples of the Kulin nation. We
              acknowledge that sovereignty was never ceded and pay our respects
              to elders past, present and emerging across Australia.
            </p>
            <p className="mt-2 text-xs font-normal leading-tight text-secondary">
              As an organisation we benefit from the rich history of
              contributions that Aboriginal and/or Torres Strait Islander people
              have made to the world.
            </p>
          </div>
        </div>
        <div className="flex-1 mt-5 lg:ml-16 md:mt-0">
          <h4 className="py-5 text-xl font-semibold text-secondary">Company</h4>
          <ul>
            {companyNav.map(({ uid, title, nodeUri, newWindow, type }) => (
              <li key={uid}>
                <NavLink newWindow={newWindow} nodeUri={nodeUri} type={type}>
                  <span className="footerSubHeadings text-secondary 2xl:text-lg">
                    {title}
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex-1 mt-5 md:mt-0">
          <h4 className="py-5 text-xl font-semibold text-secondary">Support</h4>
          <ul>
            {supportNav.map(({ uid, title, nodeUri, newWindow, type }) => (
              <li key={uid}>
                <NavLink newWindow={newWindow} nodeUri={nodeUri} type={type}>
                  <span className="footerSubHeadings text-secondary 2xl:text-lg">
                    {title}
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex-1 mt-5 sm:mt-8 md:mt-0">
          <h4 className="py-5 mb-0 text-xl font-semibold text-secondary">
            Stay in Touch
          </h4>
          <div className="flex items-center gap-4">
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://facebook.com/CodeforAustralia/"
            >
              <span className="sr-only">Facebook</span>
              <Facebook className="w-6 h-6 text-secondary hover:text-primary" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://twitter.com/codeforaus"
            >
              <span className="sr-only">Twitter</span>
              <Twitter className="w-6 h-6 text-secondary hover:text-primary" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://vimeo.com/codeforaustralia"
            >
              <span className="sr-only">Vimeo</span>
              <Vimeo className="w-6 h-6 text-secondary hover:text-primary" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.linkedin.com/company/code-for-australia/"
            >
              <span className="sr-only">Linkedin</span>
              <Linkedin className="w-6 h-6 text-secondary hover:text-primary" />
            </a>
          </div>
          <div className="flex items-center gap-2">
            <a
              href="https://blog.codeforaustralia.org/were-officially-a-b-corporation-7c32df60c185"
              rel="noopener noreferrer"
              target="_blank"
            >
              <span className="sr-only">We are a certified B-Corp</span>
              <img src={Img1} alt="B Corp" className="mr-5" />
            </a>
            <a
              href="https://slack.codeforaustralia.org/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <span className="sr-only">Join us on Slack</span>
              <img src={Slack} alt="image1" className="mt-6" />
            </a>
          </div>
        </div>
      </div>
      <div className="flex justify-center pb-6 text-xs">
        Copyright © 2022 Code for Aus Pty Ltd.
      </div>
    </div>
  )
}
